import { stringify } from 'fast-querystring';
import { failure, success } from './either.js';
export function parseQueryParams({ queryParams, queryParamsSchema, path, }) {
    if (!queryParams) {
        return success('');
    }
    if (!queryParamsSchema) {
        return success(`?${stringify(queryParams)}`);
    }
    const result = queryParamsSchema.safeParse(queryParams);
    if (!result.success) {
        console.error({
            path,
            queryParams,
            error: result.error,
        });
        return failure(result.error);
    }
    return success(`?${stringify(queryParams)}`);
}
//# sourceMappingURL=queryUtils.js.map